export const OUTPUT_ENTITY_TYPES = new Set(["entity", "result"])

function resolveEvidenceLabel(primitiveItem) {
  if (!primitiveItem) {
    return "Item"
  }
  const label =
    primitiveItem.metadata?.title ||
    primitiveItem.referenceParameters?.title ||
    primitiveItem.referenceParameters?.name ||
    primitiveItem.title ||
    primitiveItem.type ||
    "Item"
  return String(label).trim() || "Item"
}

function sortGroups(groups) {
  return groups.sort((a, b) => {
    if (b.count !== a.count) {
      return b.count - a.count
    }
    return a.title.localeCompare(b.title)
  })
}

export function groupPrimitivesByType(descendants, allowedTypes = OUTPUT_ENTITY_TYPES) {
  if (!Array.isArray(descendants) || descendants.length === 0) {
    return []
  }

  const seen = new Set()
  const grouped = new Map()
  for (const primitiveItem of descendants) {
    if (!primitiveItem || !allowedTypes.has(primitiveItem.type)) {
      continue
    }
    if (primitiveItem.flowElement) {
      continue
    }
    if (primitiveItem.type === "search" && primitiveItem.primitives?.config?.allIds?.length) {
      continue
    }
    if (seen.has(primitiveItem.id)) {
      continue
    }
    seen.add(primitiveItem.id)
    const key = resolveEvidenceLabel(primitiveItem)
    const entry = grouped.get(key) || { title: key, count: 0, items: [] }
    entry.count += 1
    entry.items.push(primitiveItem)
    grouped.set(key, entry)
  }

  return sortGroups(Array.from(grouped.values()))
}
